const BASE = '/api';

function getToken() {
  return sessionStorage.getItem('access_token') || '';
}

function getAuthHeaders() {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

export async function login(email, password) {
  const res = await fetch(`${BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || 'Login failed');
  }
  const data = await res.json();
  sessionStorage.setItem('access_token', data.access_token);
  sessionStorage.setItem('refresh_token', data.refresh_token);
  sessionStorage.setItem('user_email', data.user.email);
  return data;
}

export function logout() {
  sessionStorage.removeItem('access_token');
  sessionStorage.removeItem('refresh_token');
  sessionStorage.removeItem('user_email');
}

export function getStoredEmail() {
  return sessionStorage.getItem('user_email') || '';
}

export function isLoggedIn() {
  return !!sessionStorage.getItem('access_token');
}

export async function fetchTemplate() {
  const res = await fetch(`${BASE}/template`, { headers: getAuthHeaders() });
  if (res.status === 401) throw new Error('AUTH');
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function saveTemplate(template) {
  const res = await fetch(`${BASE}/template`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(template),
  });
  if (res.status === 401) throw new Error('AUTH');
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function fetchPreview(template) {
  const res = await fetch(`${BASE}/preview`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ template }),
  });
  if (res.status === 401) throw new Error('AUTH');
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function testBroadcast() {
  const res = await fetch(`${BASE}/test-broadcast`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  if (res.status === 401) throw new Error('AUTH');
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function fetchPlatformAvailability() {
  const res = await fetch(`${BASE}/platforms`, { headers: getAuthHeaders() });
  if (res.status === 401) throw new Error('AUTH');
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function fetchLatestItems() {
  const res = await fetch(`${BASE}/latest-items`, { headers: getAuthHeaders() });
  if (res.status === 401) throw new Error('AUTH');
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function fetchWhatsappStatus() {
  const res = await fetch(`${BASE}/whatsapp/status`, { headers: getAuthHeaders() });
  if (res.status === 401) throw new Error('AUTH');
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function setWhatsappLinkMode(mode, phoneNumber) {
  const res = await fetch(`${BASE}/whatsapp/link-mode`, {
    method: 'POST',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ mode, phoneNumber }),
  });
  if (res.status === 401) throw new Error('AUTH');
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || 'Failed to switch linking method');
  }
  return res.json();
}

export async function fetchWhatsappChats() {
  const res = await fetch(`${BASE}/whatsapp/chats`, { headers: getAuthHeaders() });
  if (res.status === 401) throw new Error('AUTH');
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || 'Failed to load chats');
  }
  return res.json();
}

export async function reconnectWhatsapp() {
  const res = await fetch(`${BASE}/whatsapp/reconnect`, {
    method: 'POST',
    headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
  });
  if (res.status === 401) throw new Error('AUTH');
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || 'Failed to reconnect WhatsApp');
  }
  return res.json();
}
